export default (location) => ({
  hospitalLocations: location.hospital_locations || location.hospitalLocations,
  jobCount: location.total_openings || location.totalOpenings,
  market: location.market,
  maxSalary: location.max_salary || location.maxSalary,
});
